import $ from 'jquery';
import * as report from './dataReport';
const mobileIndex = [0, 1, 3, 4];
const upLoadTimeKey = ['首页', '資訊', '攻略', '世界觀', '遊戲特色'];
$(function () {
  const isPhone = window.platform.isPhone();
  window.fullpage = new fullpage('#fullPage', {
    licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
    normalScrollElements: '.j-life-popup',
    scrollingSpeed: 1200,
    onLeave: function (origin, destination, direction) {
      let to = destination.index;
      let from = origin.index;
      $(`.section${from + 1}`).addClass('show_water mask');
      $(`.section${to + 1}`).addClass('lastPage');
      let activeMenuIndex = isPhone ? mobileIndex[to] : to;
      let uploadIndex = isPhone && from > 0 ? from + 1 : from;
      report.uploadTimeCounter(upLoadTimeKey[uploadIndex]);
      $('.j-menu-top-btn')
        .removeClass('active')
        .eq(activeMenuIndex)
        .addClass('active');
      isPhone && activeMenuIndex === 1 && $('.j-same-page').addClass('active');
      timer && clearTimeout(timer);
      let timer = setTimeout(() => {
        $(`.section${from + 1}`).removeClass('show_water mask nextPage');
        $(`.section${to + 1}`)
          .removeClass('lastPage')
          .addClass('nextPage');
      }, 1200);
      from === 0 &&
        !$('.j-top-list').hasClass('active') &&
        $('.j-menu-top').trigger('click');
    },
  });
  $('.j-menu-top-btn').on('click', ({ target }) => {
    if (!target.dataset.index) {
      return;
    }
    const index = ~~target.dataset.index;
    $('.j-menu-top-btn').removeClass('active').eq(index).addClass('active');
    isPhone && index === 1 && $('.j-same-page').addClass('active');
    fullpage.moveTo(index + 1);
  });
});
